import { render, staticRenderFns } from "./fyindex.vue?vue&type=template&id=34667e0e&scoped=true"
import script from "./fyindex.vue?vue&type=script&lang=js"
export * from "./fyindex.vue?vue&type=script&lang=js"
import style0 from "./fyindex.vue?vue&type=style&index=0&id=34667e0e&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34667e0e",
  null
  
)

export default component.exports